import { Header } from "./header";

interface AppShellProps {
  children: React.ReactNode;
  fluid?: boolean;
}

export function AppShell({ children, fluid = false }: AppShellProps) {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main
        className="pt-16 md:pt-28 transition-all duration-300 min-h-screen"
      >
        <div className={`p-4 md:p-6 ${fluid ? "w-full max-w-[98%] mx-auto" : "max-w-7xl mx-auto"}`}>
          {children}
        </div>
      </main>
    </div>
  );
}
